import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Box, Typography } from '@material-ui/core';
import { isNumber } from 'utils';
import Drawer from '../../../Drawer';
import Form from '../../../Form';
import Button from '../../../Button';
import Preloader from '../../../Preloader';

const PHONE_TYPES = [
  {
    name: 'Mobile',
    value: 'MOBILE',
  },
  {
    name: 'Other',
    value: 'OTHER',
  },
];

const AddProfileForm = ({ classes, change, submit, submitting, invalid, handleSubmit }) => {
  const [phoneTypesOpened, setPhoneTypesOpened] = React.useState(false);

  const handlePhoneTypeSelect = (value) => {
    change('phoneType', value);
    setPhoneTypesOpened(false);
  };

  return (
    <>
      {submitting && <Preloader />}
      <Form onSubmit={handleSubmit} autocompete="off" className={classes.container}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Form.Input name="firstName" label="First Name" required />
          </Grid>
          <Grid item xs={6}>
            <Form.Input name="lastName" label="Last Name" required />
          </Grid>
          <Grid item xs={6}>
            <Form.Input name="phone" label="Phone Number" parse={isNumber} required />
          </Grid>
          <Grid item xs={6}>
            <Form.Select
              name="phoneType"
              label="Type"
              aria-label="select"
              onClick={() => setPhoneTypesOpened(true)}
              required
              readOnly
            >
              {PHONE_TYPES}
            </Form.Select>
          </Grid>
          <Grid item xs={12}>
            <Form.Input name="email" label="Email Address" required />
          </Grid>
        </Grid>
        <div className={classes.growBlock} />
        <Grid container>
          <Button
            onClick={submit}
            label="Create Profile"
            disabled={submitting || invalid}
            data-testid="btn-shipping-form-update"
          />
        </Grid>
      </Form>
      <Drawer title="Phone Type" open={phoneTypesOpened} onClose={() => setPhoneTypesOpened(false)}>
        <Box className={classes.phoneTypesContainer}>
          {PHONE_TYPES.map(({ name, value }) => (
            <Typography variant="body1" className={classes.phoneTypeItem} onClick={() => handlePhoneTypeSelect(value)}>
              {name}
            </Typography>
          ))}
        </Box>
      </Drawer>
    </>
  );
};

AddProfileForm.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
};

AddProfileForm.defaultProps = {
  classes: {},
};

export default AddProfileForm;
